import { render, staticRenderFns } from "./StocksTable.vue?vue&type=template&id=83d47fae&"
import script from "./StocksTable.vue?vue&type=script&lang=ts&"
export * from "./StocksTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports